import "./home.css";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderProtected from "../../componentes/headerProtected/header";
import Sidebar from "../../componentes/sideBar/SideBar";
import Requests from "../../componentes/fluxo-engenheiro/Requests/requests";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";
import Notification from "../../componentes/fluxo-tax/Notification/notification";
import { useNotification } from "../../hooks/useNotification";
import SucessIcon from "../../assets/svgs/sucess.svg";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    notification,
    labelNotification,
    backgroundColor,
    setNotification,
    showNotification,
  } = useNotification();

  useEffect(() => {
    const successMessage = location.state?.successMessage;
    if (!successMessage) return;

    showNotification(successMessage);
    navigate(location.pathname, { replace: true, state: null });
  }, [location.pathname, location.state, navigate, showNotification]);

  return (
    <>
      <Sidebar />
      <HeaderProtected />
      <div className="homeMain">
        <Requests />
      </div>
      <SupportFooter />
      {notification && (
        <Notification
          label={labelNotification}
          backgroundError={backgroundColor}
          setNotification={setNotification}
          img={SucessIcon}
        />
      )}
    </>
  );
};

export default Home;
